import { __decorate, __metadata, __param } from "tslib";
import { LAB_STATUS, } from '@/apis/service/lab/LabApi.types';
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { LAB_URI } from '@/config/envConfig';
let LabService = class LabService {
    constructor(labApi, authService, accountApi) {
        this.labApi = labApi;
        this.authService = authService;
        this.accountApi = accountApi;
    }
    getAccounts(email) {
        return this.accountApi.getListAccounts({
            s_email: email,
            sEcho: 1,
            iDisplayLength: 20,
            iDisplayStart: 0,
        }).then(res => {
            return res.aaData.map((el) => {
                return {
                    developer_id: el.id,
                    email: el.email,
                };
            });
        });
    }
    getAppsPagination(params) {
        return this.labApi.getAppsPagination(params).then(res => {
            return res.data;
        });
    }
    putAppStaging(params) {
        return this.labApi.putAppStaging(params);
    }
    putAppsApp(params) {
        return this.labApi.putAppsApp(params);
    }
    putAppsAppUsed(params) {
        return this.labApi.putAppsAppUsed(params);
    }
    getStagingStatisticsApi() {
        return this.labApi.getStagingStatisticsApi();
    }
    getScoreRankingApi(includeInternal) {
        return this.labApi.getScoreRankingApi({
            page: 1,
            limit: 20,
            s_filter_internal: !includeInternal,
        });
    }
    getUsedStatisticsApi(includeInternal) {
        return this.labApi.getUsedStatisticsApi({
            page: 0,
            limit: 20,
            s_filter_internal: !includeInternal,
        });
    }
    getAppOpenTrend(params) {
        return this.labApi.getAppOpenTrend(params);
    }
    getAppOpenDetails(params) {
        return this.labApi.getAppOpenDetails(params);
    }
    getAppDetailUrl(id) {
        return `${LAB_URI}/marketplace/app/${id}/detail`;
    }
    getUsedStatisticsUserApi(app_id, params) {
        return this.labApi.getUsedStatisticsUserApi(app_id, params);
    }
    deleteApp(data) {
        return this.labApi.deleteApp(data);
    }
    /**
     * 是否是当前用户创建的
     */
    isCurrentUserCreated({ developer_id }) {
        return developer_id === this.authService.currentUser.id;
    }
    /**
     * 显示通过
     */
    showPass(row) {
        return row.staging === LAB_STATUS.REVIEW && !this.isCurrentUserCreated(row);
    }
    /**
     * 显示拒绝
     */
    showReject(row) {
        return row.staging === LAB_STATUS.REVIEW && !this.isCurrentUserCreated(row);
    }
    /**
     * 显示下架
     */
    showOffLine(row) {
        return row.staging === LAB_STATUS.APPROVED && !this.isCurrentUserCreated(row);
    }
    /**
     * 显示重新上架
     */
    showReOnLine(row) {
        return row.staging === LAB_STATUS.OFFLINE && !this.isCurrentUserCreated(row);
    }
    /**
     * 显示预览
     */
    showView(row) {
        return row.icon;
    }
    /**
     * 显示删除
     */
    showDelete(row) {
        return row.staging === LAB_STATUS.OFFLINE && !this.isCurrentUserCreated(row);
    }
    // #region Feedback
    searchFeedback(params) {
        return this.labApi.searchFeedback(params);
    }
    feedbackPass(params) {
        return this.labApi.feedbackPass(params);
    }
    feedbackRefuse(params) {
        return this.labApi.feedbackRefuse(params);
    }
    deleteFeedback(id) {
        return this.labApi.deleteFeedback(id);
    }
    // 待审核的状态下显示通过或者拒绝
    showFeedbackPass(status) {
        return status === LAB_STATUS.REVIEW || status === LAB_STATUS.REJECTED;
    }
    showFeedbacREJECTED(status) {
        return status === LAB_STATUS.REVIEW || status === LAB_STATUS.APPROVED;
    }
    showFeedbackDelete(status) {
        return status === 'deleted';
    }
    // 审核通过显示回复
    showFeedbackReply(status) {
        return status === LAB_STATUS.APPROVED;
    }
    getFeedbackInfoUrl(id) {
        return `${LAB_URI}/feedback/detailsFeedback?id=${id}`;
    }
};
LabService = __decorate([
    injectable(),
    __param(0, inject(Symbols.LabApi)),
    __param(1, inject(Symbols.AuthService)),
    __param(2, inject(Symbols.AccountApi)),
    __metadata("design:paramtypes", [Object, Object, Object])
], LabService);
export { LabService };
